SingleProduct.service( 'CartSrv', [ '$http', '$q', 'API_URL', 'DATA', function( $http, $q, API_URL, DATA ) {
	return {

		addToCart: function( items ) {
			var deffered = $q.defer();
			$http.post( API_URL.CART , items ).then(
				function( response ) {
					deffered.resolve( response.status );
				}, function (error){
					deffered.reject(error);
				}
			)
			return deffered.promise;
		},

		getRelatedProducts: function() {
			var deffered = $q.defer();
			$http.get( API_URL.RELATED_PRODUCTS + '/' + DATA.PRODUCT_ID ).then(
				function( response ) {
					deffered.resolve( response.data );
				}, function (error){
					deffered.reject(error);
				}
			)
			return deffered.promise;
		}
	}
}])